const CALL_STATUS_COLORS: Record<string, string> = {
  completed: 'green',
  transferred: 'blue',
  failed: 'red',
  no_answer: 'orange',
  busy: 'yellow',
  reaped: 'gray',
  active: 'teal',
};

export function toMs(timestamp: string) {
  return new Date(timestamp).getTime();
}

export function formatPhone(value: string) {
  const digits = value.replace(/\D/g, '');

  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;

  return value;
}

export function formatDuration(seconds: number) {
  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);

  if (minutes < 60) return `${minutes}m ${seconds % 60}s`;

  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
}

export function formatClock(seconds: number) {
  return `${Math.floor(Math.max(0, seconds) / 60)}:${Math.floor(Math.max(0, seconds) % 60)
    .toString()
    .padStart(2, '0')}`;
}

export function elapsedSeconds(startedAt: string, now: number) {
  return Math.max(0, Math.floor((now - toMs(startedAt)) / 1000));
}

export function formatElapsed(startedAt: string, now: number) {
  return formatClock(elapsedSeconds(startedAt, now));
}

export function formatDateTime(timestamp: string) {
  return new Date(timestamp).toLocaleString();
}

export function formatWhen(timestamp: string) {
  return new Date(timestamp).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function formatStamp(timestamp: string) {
  return new Date(timestamp).toLocaleString([], {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

export function formatTimeOfDay(timestamp: string) {
  return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export function timeAgo(timestamp: string) {
  const seconds = Math.floor((Date.now() - toMs(timestamp)) / 1000);

  if (seconds < 60) return 'Just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;

  return `${Math.floor(seconds / 86400)}d ago`;
}

export function callStatusColor(status: string) {
  return CALL_STATUS_COLORS[status] ?? 'gray';
}

export function durationBetween(startedAt: string, endedAt: string | null | undefined) {
  return endedAt ? Math.max(0, Math.floor((toMs(endedAt) - toMs(startedAt)) / 1000)) : 0;
}
